module.exports = __webpack_public_path__ + "img/张智威.87d836f1.png";